import { useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import { MainModalStyles } from './MainModalStyles';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import { countries } from '../../_data';
import { Lang, modeStateType } from '../../_types';
import * as formik from 'formik';
import * as yup from 'yup';
import 'react-datepicker/dist/react-datepicker.css';

interface IMainModalProps {
  show: boolean;
  handleClose: () => void;
  state: modeStateType;
  isLoading: boolean;
  takeScreenshot: (values: IFormikValues) => void;
  lang: Lang;
  error: string;
}

export interface IFormikValues {
  firstName?: string;
  lastName?: string;
  email?: string;
  phone?: string;
  message?: string;
  country?: string;
  city?: string;
}

const MainModal = ({
  show = false,
  isLoading = false,
  handleClose = () => {},
  takeScreenshot,
  lang = 'en',
  error,
}: IMainModalProps) => {
  const [validated, setValidated] = useState<boolean>(false);
  const { Formik } = formik;
  const schema = yup.object().shape({
    firstName: yup.string().required('First name is required'),
    lastName: yup.string().required('Last name is required'),
    email: yup.string().required('Email is required').email('Incorrect email'),
    phone: yup
      .string()
      .required('Phone is required')
      .min(8, 'please enter a valid phone number'),
    message: yup.string(),
    country: yup.string(),
    city: yup.string().required('City is required'),
  });

  const formikSubmit = (values: IFormikValues) => {
    takeScreenshot(values);
  };

  return (
    <MainModalStyles show={show} onHide={handleClose}>
      <div className={`loading__container ${isLoading ? '' : 'hide'}`}></div>
      <Formik
        validationSchema={schema}
        onSubmit={formikSubmit}
        initialValues={{
          email: '',
          phone: '',
          message: '',
          firstName: '',
          lastName: '',
          city: '',
          country: 'Spain',
          // city: 'New york',
          // firstName: 'vmts',
          // lastName: 'vmts',
          // email: 'huynhchihieu.bk@gmail.com',
          // phone: '0905109777',
          // message: 'no comment',
        }}
      >
        {({ handleSubmit, handleChange, values, touched, errors }) => (
          <Form noValidate validated={validated} onSubmit={handleSubmit}>
            <Modal.Header closeButton>
              <Modal.Title>Customer Information</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Row className="mb-3">
                <Form.Group as={Col} md="12" controlId="name">
                  <Form.Label>First Name *</Form.Label>
                  <Form.Control
                    type="text"
                    name="firstName"
                    value={values.firstName}
                    onChange={handleChange}
                    autoComplete="off"
                    // placeholder="Christian"
                    isInvalid={touched.email && !!errors.firstName}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.firstName}
                  </Form.Control.Feedback>
                </Form.Group>
              </Row>
              <Row className="mb-3">
                <Form.Group as={Col} md="12" controlId="name">
                  <Form.Label>Last Name *</Form.Label>
                  <Form.Control
                    type="text"
                    name="lastName"
                    value={values.lastName}
                    onChange={handleChange}
                    autoComplete="off"
                    // placeholder="Louis"
                    isInvalid={touched.email && !!errors.lastName}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.lastName}
                  </Form.Control.Feedback>
                </Form.Group>
              </Row>
              <Row className="mb-3">
                <Form.Group as={Col} md="12" controlId="email">
                  <Form.Label>Email *</Form.Label>
                  <Form.Control
                    autoComplete="off"
                    value={values.email}
                    onChange={handleChange}
                    isInvalid={touched.email && !!errors.email}
                    type="email"
                    name="email"
                    // placeholder="infor@gmail.com"
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.email}
                  </Form.Control.Feedback>
                </Form.Group>
              </Row>
              <Row className="mb-3">
                <Form.Group as={Col} md="12" controlId="phone">
                  <Form.Label>Phone *</Form.Label>
                  <Form.Control
                    autoComplete="off"
                    type="text"
                    // placeholder="0123456789"
                    isInvalid={touched.phone && !!errors.phone}
                    value={values.phone}
                    onChange={handleChange}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.phone}
                  </Form.Control.Feedback>
                </Form.Group>
              </Row>
              <Row className="mb-3">
                <Form.Group as={Col} md="12" controlId="note">
                  <Form.Label>More Comments</Form.Label>
                  <Form.Control
                    name="message"
                    value={values.message}
                    onChange={handleChange}
                    as="textarea"
                  />
                </Form.Group>
              </Row>
              <Row className="mb-3">
                <Form.Group as={Col} md="12" controlId="note">
                  <Form.Label>Country</Form.Label>
                  <Form.Select
                    name="country"
                    value={values.country}
                    onChange={handleChange}
                    aria-label="Default select example"
                  >
                    {countries.map((country) => {
                      return (
                        <option key={country.id} value={country.name}>
                          {country.name}
                        </option>
                      );
                    })}
                  </Form.Select>
                </Form.Group>
              </Row>
              <Row className="mb-3">
                <Form.Group as={Col} md="12" controlId="name">
                  <Form.Label>City *</Form.Label>
                  <Form.Control
                    type="text"
                    name="city"
                    value={values.city}
                    onChange={handleChange}
                    autoComplete="off"
                    // placeholder="New York"
                    isInvalid={touched.email && !!errors.city}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.city}
                  </Form.Control.Feedback>
                </Form.Group>
              </Row>
            </Modal.Body>
            <Modal.Footer>
              {error && <div className="error__announce">{error}</div>}
              <div className="submit__button__container">
                <button type="submit" className="submit__button">
                  {isLoading ? (
                    <span>
                      {lang === 'es' ? 'Descargar proyecto' : 'Send Project'}
                      <i></i>
                      <i></i>
                      <i></i>
                    </span>
                  ) : lang === 'es' ? (
                    'Descargar proyecto'
                  ) : (
                    'Send Project'
                  )}
                </button>
              </div>
            </Modal.Footer>
          </Form>
        )}
      </Formik>
    </MainModalStyles>
  );
};

export default MainModal;
